'use client'

import { useConsent } from "../../../providers/ConsentProvider"; 

type ConsentFooterLinkProps = {

}

export default function ConsentFooterLink({

}: ConsentFooterLinkProps) {

    const { resetConsent } = useConsent();

    return ( 
        <>
            <a href='#' onClick={(e) => {
                e.preventDefault()
                resetConsent()
            }}>Cookies</a> 
        </>
    )
}